import React, { useEffect, useState } from 'react'
import logoimg from '../../assets/MK1.3.png';
import senddata from "../../Data/data.js";
import { useLocation, useNavigate } from 'react-router-dom';

function ChoosefromQuestionBank() {

    const navigate = useNavigate();
    const location = useLocation();
    var {level,selectedquestions,selected_ids,examtype} = location.state;

    const [allQuestions,setAllQuestions]=useState([]);
    const [filteredQuestions,setFilteredQuestions]=useState([]);
    const [searchText,setSearchText]=useState("");
    const [searchLevel,setSearchLevel]=useState(level);
    const [searchLec,setSearchLec]=useState("");
    const [loading,setLoading]=useState(false);

    const [selectedq,setSelectedq] = useState(selectedquestions);
    const [selectedIds,setSelectedIds] = useState(selected_ids);

    useEffect(()=>{
        console.log("filteredData1")
        filterQuestions();
    },[searchText,searchLevel,searchLec,allQuestions])

    useEffect(()=>{
        setLoading(true);
        getAllQuestions();
      },[])

    const getAllQuestions =() =>{
        senddata("questionbank/get_questions",{}, "GET").then((res) => {
          if (res.status !== 200) {
          alert('تأكد من الاتصال من الانترنت ');
          } else {
            setAllQuestions(res.data);
            setLoading(false);
          }
          });
      }

      const filterQuestions =()=>{
        if(searchText){
          const filteredData = allQuestions.filter((question)=> (question.year==searchLevel&& ((question.lec+question.question+question.answer_1+question.answer_2+question.answer_3+question.answer_4).toLowerCase().includes(searchText.toLowerCase()) )) );
          setFilteredQuestions(filteredData);
        }else{
          const filteredData = allQuestions.filter((question)=> ( question.year==searchLevel ) );
          setFilteredQuestions(filteredData);
        }
      }

      const addQuestion = (question) => {
        const id = question._id;
        const isSelected = selectedIds.includes(id);

        if (isSelected) {
            // Remove question from selected arrays
            setSelectedIds((prevIds) => prevIds.filter(qId => qId !== id));
            setSelectedq((prevQuestions) => prevQuestions.filter(q => q._id !== id));
        } else {
            // Add question to selected arrays
            setSelectedIds((prevIds) => [...prevIds, id]);
            setSelectedq((prevQuestions) => [...prevQuestions, question]);
        }
    };

    const addToExam =()=>{
      if(examtype=="examinvideo"){
        navigate("/examInVideo",{state:{selectedIds:selectedIds,selectedq:selectedq}})
      }else if (examtype=="examincourse"){
        navigate("/examincourse",{state:{selectedIds:selectedIds,selectedq:selectedq}})
      }else{
        navigate("/generalexams",{state:{selectedIds:selectedIds,selectedq:selectedq}})
      }
    }


  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      <div className='headers  '>
          <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
      </div>
      {/* loading */}
      {loading&&<p>loading</p>}
      {/* filteratuin */}
      <div className='flex flex-row items-center justify-between mb-10 px-[5%]'>
        <input value={searchText} onChange={(e)=>{setSearchText(e.target.value)}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right" placeholder='البحث'/>
        <select value={searchLevel} onChange={(event)=>{setSearchLevel(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
          <option value="six-pri" className=' text-black'>ستة ابتدائي</option>
          <option value="one-pre" className=' text-black'>اولي اعدادي</option>
          <option value="two-pre" className=' text-black'>تانية اعدادي</option>
          <option value="three-pre" className=' text-black'>تالتة اعدادي</option>
          <option value="one-sec" className=' text-black'>اولي ثانوي</option>
          <option value="two-sec" className=' text-black'>تانية ثانوي</option>
          <option value="three-sec" className=' text-black'>تالتة ثانوي</option>
        </select>
        </div>
      {/* show questions */}
      {filteredQuestions.length&&
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[90%] ml-[5%] '>
            {
              filteredQuestions?.map((question,key)=>{
                const id =question._id
                return(
                  <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                    {question.img!="empty" && <div className=' grid grid-cols-1 rever gap-4'>
                      <img src={question.img} className='w-full mb-4 ' />
                    </div>}
                    <div className='p-3'>
                    <p className=' text-center text-[#e9ad03]'>{"السؤال"+" " +key} </p>
                        <p dir='rtl' > 👈 {question.question}</p>
                        {/* choice */}
                        {question.role=="choice"&&<p className=' text-center text-[#e9ad03]'>الاختيارات</p>}
                        {question.role=="choice"&&<>
                        <p className='mr-4' dir='rtl' >1- {question.answer_1}</p>
                        <p className='mr-4' dir='rtl' >2- {question.answer_2}</p>
                        <p className='mr-4' dir='rtl' >3- {question.answer_3}</p>
                        <p className='mr-4' dir='rtl' >4- {question.answer_4}</p>
                        </>}
                        {/* correct */}
                        {question.role=="correct"&&<p className=' text-center text-[#e9ad03]'>الاجابة صحيحة</p>}
                        {question.role=="correct"&&<>
                        <p className='mr-4' dir='rtl' >{question.answer_1}</p>
                        </>}
                        {/* text */}
                        {question.role=="text"&&<p className=' text-center text-[#e9ad03]'>الاجابات المحتملة للقطعة</p>}
                        {question.role=="text"&&<>
                        <p className='mr-4' dir='rtl' > {question.answer_1}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_2}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_3}</p>
                        <p className='mr-4' dir='rtl' > {question.answer_4}</p>
                        </>}
                        {/* dialogue */}
                        {question.role=="dialogue"&&<p className=' text-center text-[#e9ad03]'>تكملة المحادثة</p>}
                        {
                          question.role=="dialogue" && question?.dialoguecompletionSpaces.length && question?.dialoguecompletionSpaces?.map((item,i)=>{
                            return(
                            <>
                              <p className='mr-4' dir='rtl' > {i+1} : </p>
                              <>
                                {item.length&&item?.map((answer)=>{
                                   return(<p className='mr-4' dir='rtl' > {answer} </p>)
                                })}
                              </>
                            </>
                          )
                          })
                        }
                        {/* complete */}
                        {question.role=="complete"&&<p className=' text-center text-[#e9ad03]'>التكملة الصحيحة</p>}
                        {
                          question.role=="complete" && question?.correctcomplete.length && question?.correctcomplete?.map((item,i)=>{
                            return(
                            <>
                              <p className='mr-4' dir='rtl' > {i+1} : {item} </p>
                            </>
                          )
                          })
                        }


                      <div className=' grid grid-cols-3 rever gap-4'>
                        {/* choice */}
                        {question.role=="choice"&&<p>{question.correctChoice=="answer_1"? "A":question.correctChoice=="answer_2"?"B":question.correctChoice=="answer_3"?"C":question.correctChoice=="answer_4"?"d":""} الاجابة</p>}
                        {/* bolean */}
                        {question.role=="boolean"&&<p>{question.correctBoolean=="answer_1"?"الاجابة صحيحة":"الاجابة خاطئة"}</p>}
                        <p>{question.mark} : الدرجة</p>
                        <div>
                          <span>
                            ❌ {question.wrongAnswerCount}
                          </span>
                          <span> 
                            ✅ {question.correctAnswerCount}
                          </span>  
                        </div>
                      </div>


                      <div className='flex justify-between items-center mt-4'>
                        <div className='flex '>
                        {
                        selectedIds.includes(id)?
                        <p onClick={()=>{addQuestion(question)}} className='mr-4 text-lg cursor-pointer px-6 py-2 bg-[#eb0000] ml-auto w-fit rounded-full'>ازالة </p>
                        :
                        <p onClick={()=>{addQuestion(question)}} className='mr-4 text-lg cursor-pointer px-6 py-2 bg-[#e9ad03] ml-auto w-fit rounded-full'>اضافة </p>
                        } 
                        </div>
                        <p>{question.lec} : التصنيف </p>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        }

        <div className=' grid grid-cols-2 rever gap-4 mt-8 mx-4'>
            <p onClick={addToExam} className='px-6 py-2 bg-[#e9ad03] w-fit rounded-full cursor-pointer'>اضافة الي الامتحان</p> 
        </div>
        
    </div>
  )
}


export default ChoosefromQuestionBank
